import { useSelection } from 'app/agriculture/ContextMenu/hooks/useSelection/useSelection';
import { CesiumBillboard } from 'app/agriculture/FarmMain/MapRenderer/components/CesiumBillboard';
import { createHerdIcon } from 'app/agriculture/hooks/useMapRender/mapRenderUtils';
import { useContext } from 'react';
import { DraggingHerdContext } from 'app/agriculture/contexts/DraggingContextProvider';
import { useHerdsOnMap } from 'app/agriculture/queries/herds/useHerdsOnMap';
import { convertGeometryToMapLocation } from 'app/agriculture/components/utils/convertGeometryToLocation/convertGeometryToMapLocation';

export function HerdRenderer() {
    const { draggingHerdId } = useContext(DraggingHerdContext);
    const herds = useHerdsOnMap();
    const { isSelected, selection } = useSelection();

    return (
        <>
            {Array.from(herds.values()).map(
                ({ id, snapshot, location, herdType, animalSpecies }) => {
                    if (!location) return null;

                    let billboardOptions;
                    if (id == draggingHerdId) {
                        billboardOptions = createHerdIcon(
                            {
                                id,
                                location: convertGeometryToMapLocation({
                                    type: 'Point',
                                    coordinates: location,
                                }),
                                isSelected: false,
                            },
                            {
                                herdType,
                                animalSpecies,
                                totalAnimals: snapshot?.totalAnimals ?? 0,
                                isMoveIcon: false,
                            },
                        );
                    } else {
                        billboardOptions = createHerdIcon(
                            {
                                id,
                                location: convertGeometryToMapLocation({
                                    type: 'Point',
                                    coordinates: location,
                                }),
                                isSelected: isSelected(id),
                            },
                            {
                                herdType,
                                animalSpecies,
                                totalAnimals: snapshot?.totalAnimals ?? 0,
                                isMoveIcon: selection?.id == id,
                            },
                        );
                    }
                    return <CesiumBillboard key={id} billboardOptions={billboardOptions} />;
                },
            )}
        </>
    );
}
